import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { TraderService } from 'src/services/trader.service';

@Component({
  selector: 'app-incoming-orders-list',
  templateUrl: './incoming-orders-list.component.html',
  styleUrls: ['./incoming-orders-list.component.scss'],
})
export class IncomingOrdersListComponent implements OnInit {
  incomingOrdersList = [];
  selectedOrder: any;
  currencySymbol = localStorage.getItem("currencySymbol")
  constructor(
    private trader: TraderService,
    public router: Router,
    public navparam: NavParams,
    public modalController: ModalController) {
    console.log(this.navparam.data, "selected");
    this.selectedOrder = this.navparam.data.selectedOrder
  }

  ngOnInit() {

    this.incomingOrdersList = this.navparam.data.orders;

  }

  orderPick(choice) {
    console.log(choice)
    if (!choice) {
      this.modalController.dismiss({
        reason: ''
      })
    } else {
      this.modalController.dismiss({
        reason: "selected",
        data: choice
      });
    }
  }

}
